import createRoute        from '@widesk-ui/tools/createRoute';
import ParticipationModel from '@models/website/ParticipationModel';

const route = createRoute.dashboardFromModel(
	ParticipationModel,
	'ParticipationDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
